import { GetCartItemPresenter } from 'store/api-slice/hooks'
import { SpaWithDetails } from 'routes/Upsell/SpaCreator/types/spa'
import moment from 'moment'

// TODO: decide if leave here or to move into cart helpers
export const filterSpaFromCart = (items?: GetCartItemPresenter[]) => {
    const spaItems =
        (items?.filter(
            ({ productType }) => productType === 'spa_treatment'
        ) as SpaWithDetails[]) || []

    const itemsWithDescriptions = spaItems.map((spaItem) => {
        const {
            detail: { startDate },
        } = spaItem

        // decription in e.g. format: Pt. 14.03.25, 14:00
        const description = `${moment(startDate).format('ddd DD.MM.YY, HH:mm')}`
        return {
            ...spaItem,
            description,
        }
    })

    return itemsWithDescriptions as SpaWithDetails[]
}
